import { useState } from "react";
import { useSelector } from "react-redux";
import { selectAuthInitialized } from "../redux/userSlice";

const AuthGate = ({ children, fallback }) => {
  const authInitialized = useSelector(selectAuthInitialized);
  const [hasTokenSignal] = useState(() => {
    const hasUrlToken = new URLSearchParams(window.location.search).has("accessToken");
    const hasStoredToken = !!localStorage.getItem("authTokens");
    return hasUrlToken || hasStoredToken;
  });
  const shouldGate = hasTokenSignal && !authInitialized;

  return shouldGate ? fallback : children;
};

export default AuthGate;